const Background = () => (
  <div className='md:flex hidden absolute w-full h-[700px] -z-[1] justify-end'>
    <div className='relative bg-hero-bg bg-contain bg-center bg-no-repeat w-2/3'></div>
  </div>
)

export default Background
